import Typography from "../../components/shared/typography";

type SectionStatus = {
  id: string;
  title: string;
  completed: boolean;
  remaining: number;
  totalRequired: number;
};

type Props = {
  overallProgressPct: number;
  saveState: "idle" | "saving" | "saved";
  sectionStatuses: SectionStatus[];
};

export default function ProgressOverview({ overallProgressPct, saveState, sectionStatuses }: Props) {
  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-2">
        <Typography variant="body2" className="text-brown-700">
          Overall Progress: {overallProgressPct}%
        </Typography>
        <Typography variant="caption" className="text-brown-600">
          {saveState === "saving" ? "Saving…" : saveState === "saved" ? "Saved" : ""}
        </Typography>
      </div>
      <div className="h-2 w-full rounded-full bg-terracotta-100 overflow-hidden">
        <div className="h-full bg-terracotta-500 transition-all" style={{ width: `${overallProgressPct}%` }} />
      </div>
      <div className="mt-3">
        {sectionStatuses.every((s) => s.completed) ? (
          <Typography variant="caption" className="text-green-600">
            All subsections complete
          </Typography>
        ) : (
          <>
            <Typography variant="caption" className="text-brown-700">
              Remaining subsections
            </Typography>
            <div className="mt-2 flex flex-wrap gap-2">
              {sectionStatuses
                .filter((s) => !s.completed)
                .map((s) => (
                  <span
                    key={s.id}
                    className="inline-flex items-center rounded-full border border-terracotta-400 bg-white px-3 py-1 text-sm text-brown-800 shadow-sm"
                  >
                    {s.title}
                    {s.totalRequired > 0 && (
                      <span className="ml-2 rounded-full bg-terracotta-100 px-2 py-0.5 text-terracotta-700 text-xs">
                        {s.remaining} left
                      </span>
                    )}
                  </span>
                ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

